import {CategoryObj, RegulationCategory} from '@/modules/regulation/enums/RegulationCategory';
import {getBankNameById} from '@/commons/dictionaries/BanksDictionary';
import {Utils} from '@/services/utils/BasicUtils';
import EnvironmentService from '@/env/EnvironmentService';

export abstract class RegulationDTO {
  public id!: RegulationCategory;
  public category: CategoryObj = new CategoryObj({id: RegulationCategory.LENDI, name: 'Lendi', });
  public bankId: Nullable<number> = null;
  public visible: boolean = true;
  public isHighPriority: boolean = false;
  public title: string = '';
  public details: string = '';
  public isFavorite!: boolean;
  public visited!: boolean;
  public createdAt: string = (new Date()).toISOString(); // To również działa jako data publikacji
}

export default class Regulation extends RegulationDTO {
  constructor(regulationDTO?: RegulationDTO) {
    super();
    if (regulationDTO) {
      if (regulationDTO.category) {
        regulationDTO.category = new CategoryObj(regulationDTO.category);
      }
      Utils.assign(this, regulationDTO);
    }
  }

  public get categoryColor() {
    const chipColors: {[key: number]: string} = {
      [RegulationCategory.MORTGAGE]: 'var(--token-mortgage-surface)',
      [RegulationCategory.CASH]: 'var(--token-cash-surface)',
      [RegulationCategory.SME]: 'var(--token-sme-surface)',
      // PL-specific categories (8-13)
      [RegulationCategory.CONTEST]: '#5086dc',
      [RegulationCategory.LENDI]: 'var(--token-primary-base)',
      [RegulationCategory.PLATFORM]: '#687c10',
      [RegulationCategory.REPORTS]: '#ca5a1a',
      [RegulationCategory.INSURANCE]: 'var(--token-insurance-surface)',
      [RegulationCategory.LENDI_CARE]: 'var(--token-insurance-surface)',
    };

    if (EnvironmentService.Environment.isAppDomain().NESTO_RO) {
      // RO-specific categories (4-7)
      chipColors[RegulationCategory.LEASING] = '#2e7d32';
      chipColors[RegulationCategory.INTERNAL_CAMPAIGNS] = '#7b1fa2';
      chipColors[RegulationCategory.MARKETING] = '#f57c00';
      chipColors[RegulationCategory.EVENTS] = '#0288d1';
    }
    
    return chipColors[this.category.id];
  }

  public get categoryTextColor() {
    const chipColors: {[key: number]: string} = {
      [RegulationCategory.MORTGAGE]: 'var(--token-mortgage-text)',
      [RegulationCategory.CASH]: 'var(--token-cash-text)',
      [RegulationCategory.SME]: 'var(--token-sme-text)',
      [RegulationCategory.INSURANCE]: 'var(--token-insurance-text)',
      [RegulationCategory.LENDI_CARE]: 'var(--token-insurance-text)',
    };
    return chipColors[this.category.id];
  }

  public get categoryName() {
    return this.category.name;
  }

  get bankName(): string {
    // TODO:ZMIENIć TO NA STARY BGZ
    if (this.bankId === 24) {
      return 'BNP Paribas';
    }
    return this.bankId ? getBankNameById(this.bankId) : '';
  }

  public get textDecoration() {
    return (!this.visited ? 'bold ' : ' ') + (this.visible ? '' : 'color: #a6aab3egu');
  }
}
